import { Box, Checkbox, FormControl } from "@primer/react";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { clubApi } from "../../api/clubApi";
import SccopeSelectionButtonByLop from "../../components/scope-selection-button/SccopeSelectionButtonByLop";
import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import TextInput from "../../components/ui/text-input";
import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { IClubResgistrationVm } from "../../models/response/club/IClubResgistrationVm";
import MyHtmlEditor from "../../components/html-editor";
import ComboboxClubPeriod from "../../components/combobox-club-period";

interface Props {
    isOpen: boolean;
    id: number;
    onClose: () => void;
    onSuccess?: () => void;
}

const ClubRegistrationDetailModal = ({ isOpen, id, onClose, onSuccess }: Props) => {
    const fake: any = {};
    const [clubRegistration, setClubRegistration] = useState<IClubResgistrationVm>(fake);
    const { register, handleSubmit, reset, clearErrors, setError, control, formState: { errors } } = useForm<IClubResgistrationVm>({
        mode: "all"
    });
    const [htmlDescription, setHtmlDescription] = useState("");
    const [clubPeriod, setClubPeriod] = useState(0);

    const lopIdsSelected = useMemo(() => {
        return clubRegistration?.scopes?.map(x => x.dm_lop_id) ?? [];
    }, [clubRegistration]);

    useEffect(() => {
        if (id) handleGetDataAsync();
    }, [id]);

    const handleGetDataAsync = async () => {
        const res = await clubApi.clubSelectDetail(id);
        if (res.is_success) {
            setClubRegistration(res.data);
            reset({
                ...res.data
            });
            setHtmlDescription(res.data?.description ?? "")
        }
    };

    const onSubmit = async (data: any) => {
        const res = await clubApi.clubSaveChange({
            ...clubRegistration,
            ...data,
            scopes: clubRegistration.scopes,
            id: id,
            description: htmlDescription,
            sis_club_registration_period_id: clubPeriod
        });

        if (res.is_success) {
            NotifyHelper.Success("Success");
            onSuccess?.();
            onClose();
        } else {
            NotifyHelper.Error(res.message ?? "Error");
        }
    };

    return (
        <Modal
            width="xlarge"
            isOpen={isOpen}
            title="Chi tiết câu lạc bộ"
            onClose={onClose}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 3 }}>
                    <FormControl>
                        <ComboboxClubPeriod 
                        value={clubPeriod}
                        onValueChanged={(val)=>{
                            setClubPeriod(val)
                        }}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Tên câu lạc bộ</FormControl.Label>
                        <TextInput
                            register={register}
                            name="name"
                            required
                            width={'100%'}
                        />
                        {
                            errors["name"] &&
                            <FormControl.Validation variant="error">
                                Vui lòng nhập câu lạc bộ
                            </FormControl.Validation>
                        }
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Tên câu lạc bộ EN</FormControl.Label>
                        <TextInput
                            register={register}
                            name="name_en"
                            required
                            width={'100%'}
                        />
                        {
                            errors["name_en"] &&
                            <FormControl.Validation variant="error">
                                Vui lòng nhập câu lạc bộ en
                            </FormControl.Validation>
                        }
                    </FormControl>
                    {/* Scope */}
                    <FormControl>
                        <FormControl.Label>Phạm vi</FormControl.Label>
                        <SccopeSelectionButtonByLop
                            lopIdsSelected={lopIdsSelected}
                            onValueChanged={(ids: number[]) => {
                                setClubRegistration({
                                    ...clubRegistration,
                                    scopes: ids.map(lopId => ({
                                        id: 0,
                                        sis_club_registration_club_id: id,
                                        dm_lop_id: lopId
                                    }))
                                });
                                if (ids.length > 0) clearErrors("scopes");
                            }}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Sĩ số</FormControl.Label>
                        <TextInput
                            register={register}
                            name="capacity"
                            required
                            type="number"
                        />
                        {
                            errors["capacity"] &&
                            <FormControl.Validation variant="error">
                                Vui lòng nhập số lượng tối đa
                            </FormControl.Validation>
                        }
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>
                            Mô tả
                        </FormControl.Label>
                        <MyHtmlEditor
                            value={clubRegistration?.description ?? ""}
                            onValueChanged={(htmlValue) => {
                                setHtmlDescription(htmlValue)
                            }}
                        />

                    </FormControl>
                </Box>

                <ModalActions>
                    <Button text="Đóng" onClick={onClose} />
                    <Button text={id > 0 ? "Cập nhật" : "Thêm mới"} type="submit" variant="primary" />
                </ModalActions>
            </form>
        </Modal>
    );
};

export default ClubRegistrationDetailModal;